// Chic et Chat : ouvre les sous-menus de l'en-tête au survol (souris uniquement).
// Le clic et le clavier gardent le comportement Dawn d'origine.
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function init() {
    var items = document.querySelectorAll('.header__inline-menu header-menu > details');
    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      var timer;

      function open() {
        clearTimeout(timer);
        items.forEach(function (other) {
          if (other !== details && other.open) {
            other.removeAttribute('open');
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        if (!details.open) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      function close() {
        timer = setTimeout(function () {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 180);
      }

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      // Un clic souris sur un menu déjà ouvert au survol ne doit pas le refermer.
      summary.addEventListener('click', function (e) {
        if (e.detail > 0 && details.open) e.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
